export enum ApiResultsUrls {
  UserAnswers = '/api/v1.0/results/useranswers',
  GetResultsPage = '/api/v1.0/results/page',
  GetSchoolReport = '/api/v1.0/results/reports/getschoolinteractivereport',
  GetMunicipalityReport = '/api/v1.0/results/reports/getmunicipalityinteractivereport',
}
